<template>
  <div class="row">
    <div class="col-12 discipline-container">
      <PageHeader
        :page="page"
        :has-return="true"
        @onReturn="() => $router.back()"
      />

      <div class="row">
        <div class="col-12">
          <SectionTitle content="Búsqueda" :has-line="true" />
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="row pl-3">
            <div class="col-md-3 col-sm-12 py-0">
              <span>
                <custom-drop-down
                  v-model="filter.academicYear"
                  :options="academicYears"
                  placeholder="Seleccione"
                  :fieldkey="'id'"
                  :fieldname="'description'"
                  label="Año Académico:"
                />
              </span>
            </div>
            <div class="col-md-7 col-sm-12 mt-2 mt-md-0 mt-sm-2">
              <div>
                <custom-drop-down
                  v-model="filter.disciplinaryAction"
                  :options="disciplinaryActions"
                  placeholder="Seleccione"
                  :fieldkey="'eduespCodeId'"
                  :fieldname="'spaShortDescription'"
                  label="Tipo de remoción disciplinaria:"
                />
              </div>

              <div
                v-if="
                  filter.disciplinaryAction &&
                    filter.disciplinaryAction.eduespCodeId === this.code.IAES
                "
                class="col-12 d-flex justify-content-between"
              >
                <div class="col-4">
                  <div
                    class="custom-control custom-checkbox custom-control-inline"
                  >
                    <input
                      id="weaponFlag"
                      v-model="filter.weaponFlag"
                      type="checkbox"
                      class="custom-control-input"
                      name="weaponFlag"
                      @change="updateFilterValue"
                    />

                    <label class="custom-control-label font" for="weaponFlag">
                      Armas
                    </label>
                  </div>
                </div>
                <div class="col-4">
                  <div
                    class="custom-control custom-checkbox custom-control-inline"
                  >
                    <input
                      id="drugsFlag"
                      v-model="filter.drugsFlag"
                      type="checkbox"
                      class="custom-control-input"
                      name="drugsFlag"
                      @change="updateFilterValue"
                    />

                    <label class="custom-control-label font" for="drugsFlag">
                      Drogas
                    </label>
                  </div>
                </div>
                <div class="col-4">
                  <div
                    class="custom-control custom-checkbox custom-control-inline"
                  >
                    <input
                      id="bodilyInjuryFlag"
                      v-model="filter.bodilyInjuryFlag"
                      type="checkbox"
                      class="custom-control-input"
                      name="bodilyInjuryFlag"
                      @change="updateFilterValue"
                    />

                    <label
                      class="custom-control-label font"
                      for="bodilyInjuryFlag"
                    >
                      Lesión Corporal
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-md2 col-sm-12 d-flex align-items-center justify-content-end mt-2 mt-md-0 mt-sm-2"
            >
              <ActionButton variant="success" @click="LoadDisciplines()">
                Buscar
              </ActionButton>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12">
          <SectionTitle content="Disciplinas" :has-line="true" />
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div
            class="row mx-0 d-flex justify-content-between align-items-center header thead-property h-100 mh-100 py-3"
          >
            <div class="col-md-3 col-sm-6 py-0">
              <span>Tipo de Remoción Disciplinaria</span>
            </div>
            <div class="col-md-2 col-sm-6 py-0">
              <span>Disciplina</span>
            </div>
            <div class="col-md-2 col-sm-6 py-0">
              <span>Fecha</span>
            </div>
            <div class="col-md-2 col-sm-6 py-0">
              <span>Duración</span>
            </div>
            <div class="col-md-2 col-sm-6">
              <div>Fecha EDEN</div>
            </div>
            <div class="col-md-1 col-sm-12 py-0" />
            <div class="col-md-1 col-sm-12 py-0" />
          </div>
        </div>
      </div>

      <div class="row">
        <div v-for="item in rows" :key="item.label" class="col-12">
          <div class="subheader tsubhead-property d-flex align-items-center">
            <strong class="pl-2">
              {{ item.label }}
            </strong>
          </div>

          <Accordion id="accordionDiscipline">
            <AccordionItem
              v-for="itemC in item.children"
              :id="'accordionItemTerapia' + itemC.disciplineId"
              :key="itemC.disciplineId"
              :title="itemC.discActionDescription"
              :expanded="false"
              :title-bold="true"
              :is-discipline="true"
              :title-style="'col-md-3 col-sm-12'"
              :content-style="'col-md-7 col-sm-12'"
            >
              <template slot="header-content">
                <div class="col-md-2 col-sm-3 py-0 d-flex align-items-center">
                  <span class="pl-2">
                    {{ flags(itemC) }}
                  </span>
                </div>
                <div class="col-md-2 col-sm-3 py-0 d-flex align-items-center">
                  <span class="pl-2">
                    {{ itemC.disciplineDate | date }}
                  </span>
                </div>
                <div class="col-md-2 col-sm-3 py-0 d-flex align-items-center">
                  <span class="pl-2">
                    {{ itemC.discLengthDescription }}
                  </span>
                </div>
                <div class="col-md-1 col-sm-3 py-0 d-flex align-items-center">
                  <span>{{ itemC.edenReportedDate | date }}</span>
                </div>
              </template>

              <template slot="action">
                <div class="dropdown">
                  <button
                    id="ddAdiestramiento"
                    class="btn btn-dropdown-actions dropdown-toggle pt-1"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Acciones
                  </button>
                  <div class="dropdown-menu" aria-labelledby="ddAdiestramiento">
                    <a
                      v-if="isBeforeCutOffDiscipineDate"
                      class="dropdown-item"
                      @click="update(itemC)"
                    >
                      <em class="fas fa-pencil text-green" />
                      Editar
                    </a>
                    <a
                      v-if="isBeforeCutOffDiscipineDate"
                      class="dropdown-item"
                      @click.stop="showConfirmationDelete(itemC)"
                    >
                      <em class="fas fa-times-circle text-red" />
                      Eliminar
                    </a>
                  </div>
                </div>
              </template>

              <div slot="content">
                <div class="row m-0 mb-2">
                  <div class="col-md-12 col-sm-12">
                    <div class="row ml-1">
                      <div class="col-md-3 col-sm-12">
                        <strong>Region:</strong>
                        <p class="font-weight-normal">
                          {{ itemC.region_Name }}
                        </p>
                      </div>
                      <div class="col-md-2 col-sm-12 pl-3">
                        <strong>Distrito:</strong>
                        <p class="font-weight-normal">
                          {{ itemC.district_Name }}
                        </p>
                      </div>
                      <div class="col-md-4 col-sm-12 pl-3">
                        <strong>Escuela:</strong>
                        <p class="font-weight-normal">
                          {{ itemC.locationSchool_Code }} -
                          {{ itemC.locationSchool_Name | capitalize }}
                        </p>
                      </div>
                      <div class="col-md-2 col-sm-12">
                        <strong>Creación:</strong>
                        <p class="font-weight-normal">
                          {{ itemC.createDate | date }}
                          <br />
                          {{ itemC.createByFullName }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 d-flex mb-2">
                    <div class="row ml-1">
                      <div class="col-9">
                        <strong>Comentario:</strong>
                        <p class="text-justify">
                          {{ itemC.disciplineDescription }}
                        </p>
                      </div>
                      <div class="col-2 py-0">
                        <strong>Modificación:</strong>
                        <p>
                          {{ itemC.modifyDate | date }}
                          <br />
                          {{ itemC.modifyByFullName }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
      <div v-if="rows.length === 0" class="col-12 p-0">
        <div class="subheader-footer d-flex align-items-center">
          <div class="row w-100">
            <div class="col-12 pt-0 ">
              <em class="fal fa-folder-open icon" />
              <span class="tsubhead-footer">
                No hay disciplinas registradas.
              </span>
            </div>
          </div>
        </div>
      </div>

      <customPager
        ref="historyPager"
        :per-page="tableConfig.serverParams.perPage"
        :total="tableConfig.totalRecords"
        :page-changed="onPageChange"
        :per-page-changed="onPerPageChange"
      />

      <customModal
        ref="popup"
        :message-box="{
          title: 'Alerta',
          messageCode: '',
          size: 'modal-lg',
          message:
            '¿Esta seguro que desea eliminar este registro de disciplina?',
          type: 'confirm',
          icon: 'fa fa-exclamation',
        }"
        :success-callback="deleteDiscipline"
        :cancel-callback="onCloseModal"
      />
    </div>
  </div>
</template>

<style scoped>
.card-header .accordion-header .header-title {
  margin-left: 0 !important;
}
.discipline-container {
  font-weight: 400;
}
.accordion {
  background-color: #fafbfa;
}

.accordion >>> hr {
  margin-left: 45px;
  margin-right: 45px;
  border: 1px solid #dadada;
}

.accordion >>> .card-header {
  border-bottom-color: #fafbfa;
}
.accordion >>> .accordion-header[aria-expanded='false'] {
  background-color: #fafbfa;
}

.accordion >>> .accordion-header[aria-expanded='true'] {
  background-color: #fafbfa;
}

.header {
  height: 54px;
  padding-left: 20px;
  background: #3f5b60 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
  font-weight: bold;
}

.header-description {
  font-weight: bold;
}

.subheader {
  height: 54px;
  padding-left: 20px;
  background: #e7ebe9 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  font-weight: bold;
}

.thead-property {
  color: #ffffff;
}

.tsubhead-property {
  color: #11291b;
  font-weight: bold;
  font-size: 16px;
}

.subheader-footer {
  height: 150px;
  padding-left: 20px;
  background: #fafbfa 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  text-align: center;
}

.subheader-footer .icon {
  font-size: 35px;
  height: 60px;
  width: 60px;
  border: solid 3px;
  border-radius: 127px;
  padding-top: 10px;
  padding-left: 3px;
  color: #e2e2e2;
}

.tsubhead-footer {
  color: #727272;
  font-weight: bold;
  font-size: 22px;
  padding-left: 15px;
  padding-bottom: 13px;
  vertical-align: super;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}

.text-fix {
  font-weight: 400;
}
</style>

<script>
import { ActionButton } from '@/components/common';
import { SectionTitle } from '@/components/pei/shared';
import { Accordion, AccordionItem } from '@/components/pei/shared/accordion';
import customModal from '@/components/common/modal/custommodal';
import CustomDropDown from '@/components/common/CustomDropDown';
import moment from 'moment';
import store from '@/store/index';
import disciplineActionsCode from '@/utils/constants/student/disciplineActionsCode';
import mixAlert from '@/mixin/alert.mixin';
import alert from '@/mixin/alert.mixin';
import PageHeader from '@/components/common/page/PageHeader';

export default {
  name: 'Discipline',
  mixins: [mixAlert],
  components: {
    SectionTitle,
    ActionButton,
    Accordion,
    AccordionItem,
    customModal,
    CustomDropDown,
    PageHeader,
  },
  created() {
    Promise.all([this.LoadAcademicYears(), this.LoadDisciplinaryActions()]);
  },
  data() {
    return {
      sie: store.getters['$_student/StudentSie'],
      page: {
        icon: 'fas fa-user-edit',
        title: 'Histórico de Disciplina',
        routes: ['Inicio', 'Estudiante', 'Histórico de Disciplina'],
        sections: ['Busqueda', 'Disciplina'],
      },
      filter: {
        academicYear: {
          id: null,
          description: '',
        },
        disciplinaryAction: {
          eduespCodeId: null,
          spaShortDescription: '',
        },
        weaponFlag: null,
        drugsFlag: null,
        bodilyInjuryFlag: null,
      },
      code: disciplineActionsCode,
      academicYears: [],
      disciplinaryActions: [],
      rows: [],
      tableConfig: {
        totalRecords: 0,
        serverParams: {
          columnFilters: {},
          sort: {
            field: '',
            type: '',
          },
          page: 1,
          perPage: 10,
        },
      },
      discipline: {},
      isBeforeCutOffDiscipineDate: true, //Se deja hardcoded ya que se quito el uso del parámetro EDENDisciplineEndDate, por lo que se deja preparada la logica por si se requiere nuevamente a condicionar
    };
  },
  methods: {
    async LoadAcademicYears() {
      await this.$ApiGet('api/academicyears/getacademicyearstocurrentyear')
        .then((res) => {
          this.academicYears = res.data;
        })
        .catch((err) => {
          self.ShowToast('Alerta', err.message, 'error');
        });
    },
    async LoadDisciplinaryActions() {
      try {
        const { data } = await this.$ApiGet('api/student/disciplinaryactions');
        this.disciplinaryActions = data;
      } catch (error) {
        this.ShowToast('Alerta', error.message, 'error');
      }
    },
    async LoadDisciplines() {
      try {
        if (
          this.filter.disciplinaryAction &&
          this.filter.disciplinaryAction.eduespCodeId !== this.code.IAES
        ) {
          this.drugFlag = this.weaponFlag = this.bodilyInjuryFlag = null;
        }

        const { data } = await this.$ApiGet(
          '/api/student/disciplines?studentId=' +
            String(this.sie) +
            '&academicYearId=' +
            String(
              this.filter.academicYear ? this.filter.academicYear.id : null
            ) +
            '&disciplineActionCode=' +
            String(
              this.filter.disciplinaryAction
                ? this.filter.disciplinaryAction.eduespCodeId
                : null
            ) +
            '&weaponFlag=' +
            String(this.filter.weaponFlag) +
            '&drugsFlag=' +
            String(this.filter.drugsFlag) +
            '&bodilyInjuryFlag=' +
            String(this.filter.bodilyInjuryFlag) +
            '&pageNumber=' +
            this.tableConfig.serverParams.page +
            '&pageSize=' +
            this.tableConfig.serverParams.perPage
        );

        this.rows = data.data ? this.formatData(data.data) : [];
        this.tableConfig.totalPages = data.pageCount;
        this.tableConfig.totalRecords = data.totalItemCount;
      } catch (error) {
        this.response = error;
      }
    },
    flags(item) {
      let result;

      if (item.drugFlag !== '0') {
        if (item.weaponFlag !== '0') {
          if (item.bodilyInjuryFlag !== '0') {
            result = 'Drogas/Armas/Lesión Corporal';
          } else result = 'Drogas/Armas';
        } else if (item.bodilyInjuryFlag !== '0')
          result = 'Drogas/Lesión Corporal';
        else result = 'Drogas';
      } else if (item.weaponFlag !== '0') {
        if (item.bodilyInjuryFlag !== '0') {
          result = 'Armas/Lesión Corporal';
        } else result = 'Armas';
      } else if (item.bodilyInjuryFlag !== '0') result = 'Lesión Corporal';
      else result = 'N/A';

      return result;
    },
    goBack() {
      this.$router.push('/student');
    },
    formatData(data) {
      const rows = [];
      const group = data.reduce(function(r, a) {
        const name = 'Año Académico: ' + a.academicYearDescription;
        r[name] = r[name] || [];
        r[name].push(a);
        return r;
      }, Object.create(null));

      Object.keys(group).forEach((key) => {
        const row = {
          label: key,
          children: [],
        };

        group[key].forEach((element) => {
          const children = {
            academicYearRank: element.academicYearRank,
            disciplineId: element.disciplineId,
            discActionCode: element.discActionCode,
            discActionDescription: element.discActionDescription,
            discLengthCode: element.discLengthCode,
            discLengthDescription: element.discLengthDescription,
            disciplineDate: element.disciplineDate,
            studentSieId: element.studentSieId,
            academicYearId: element.academicYearId,
            academicYearDescription: element.academicYearDescription,
            disciplineDescription: element.disciplineDescription,
            drugFlag: element.drugFlag,
            weaponFlag: element.weaponFlag,
            bodilyInjuryFlag: element.bodilyInjuryFlag,
            createDate: element.createDate,
            createById: element.createById,
            createByFullName: element.createByFullName,
            modifyDate: element.modifyDate,
            modifyById: element.modifyById,
            modifyByFullName: element.modifyByFullName,
            deleteFlag: element.deleteFlag,
            edenReportedDate:
              element.edenReportedDate !== null
                ? element.edenReportedDate
                : null,
            locationSchool_Code: element.locationSchool_Code,
            locationSchool_Id_Pk: element.locationSchool_Id_Pk,
            locationSchool_Name: element.locationSchool_Name,
            district_Id_Pk: element.district_Id_Pk,
            district_Name: element.district_Name,
            municipality_Id_Pk: element.district_Id_Pk,
            municipality_Name: element.district_Id_Pk,
            region_Id_Pk: element.district_Id_Pk,
            region_Name: element.region_Name,
            center_Id_Pk: element.center_Id_Pk,
            center_Name: element.center_Name,
          };

          row.children.push(children);
        });

        rows.push(row);
      });

      return rows;
    },
    formatDate(date) {
      return moment(date)
        .locale('es')
        .format('DD/MMM/YYYY');
    },
    updateFilterValue(event) {
      this.filter[event.target.name] = event.target.checked ? '1' : null;
    },
    updateParams(newProps) {
      this.tableConfig.serverParams = Object.assign(
        {},
        this.tableConfig.serverParams,
        newProps
      );
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.LoadDisciplines();
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.LoadDisciplines();
    },
    update(_discipline) {
      this.discipline = _discipline;
      this.$router.push({
        name: 'AddDiscipline',
        params: { discipline: _discipline },
      });
    },
    async showConfirmationDelete(_discipline) {
      await alert.methods
        .ShowCancelModal(
          'Atención',
          '¿Está seguro que desea eliminar este registro de disciplina?',
          'Sí',
          'No'
        )
        .then((answer) => {
          if (answer) {
            this.discipline = _discipline;
            this.deleteDiscipline();
          }
        });
    },
    deleteDiscipline() {
      if (this.discipline.edenReportedDate !== null) {
        this.ShowToast(
          'Alerta',
          'No se pueden eliminar Disciplinas reportadas en EDEN',
          'error'
        );

        return;
      }

      const data = {
        Id: this.discipline.disciplineId,
        StudentSieId: this.discipline.studentSieId,
        LocationSchoolId: this.discipline.locationSchool_Id_Pk,
        DiscActionCode: this.discipline.discActionCode,
        DiscLengthCode: this.discipline.discLengthCode,
        AcademicYearId: this.discipline.academicYearId,
        BodilyInjuryFlag: this.discipline.bodilyInjuryFlag,
        DisciplineDate: this.discipline.disciplineDate,
        DisciplineDescription: this.discipline.disciplineDescription,
        DrugFlag: this.discipline.drugFlag,
        WeaponFlag: this.discipline.weaponFlag,
        DeleteFlag: '1',
        EDENReportedDate: this.discipline.edenReportedDate,
      };

      this.$ApiPost('api/student/discipline/save', data)
        .then(() => {
          this.ShowToast(
            'Proceso exitoso.',
            'La disciplina fue eliminada exitosamente',
            'success'
          );

          this.LoadDisciplines();
        })
        .catch((err) => {
          this.ShowToast('Alerta', err.message, 'error');
        });
    },
    onCloseModal() {
      this.discipline = {};
    },
  },
};
</script>
